import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { uomService } from "@/services/uom";

import type { UpdateUnitOfMeasurementReq } from "@artisancode/api-types";

export function useUoms(q?: string) {
  return useQuery({
    queryKey: queryKeys.uoms.list({ q }),
    queryFn: () => uomService.list({ q, per_page: 100 }),
  });
}

export function useCreateUom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: uomService.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.uoms.all }),
  });
}

export function useUpdateUom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      ...body
    }: { id: string } & UpdateUnitOfMeasurementReq) =>
      uomService.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.uoms.all }),
  });
}

export function useDeleteUom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => uomService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.uoms.all }),
  });
}

export function useUomUsage(id?: string) {
  return useQuery({
    queryKey: id ? queryKeys.uoms.usage(id) : (["uoms", "usage", ""] as const),
    queryFn: () => (id ? uomService.usage(id) : null),
    enabled: !!id,
  });
}
